/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyListResponse } from '../../models/company-list-response';

export interface CompanyControllerFind$Params {
  field?: 'id' | 'name' | 'mainContact' | 'email' | 'emailPec' | 'website' | 'vatNumber' | 'fiscalCode' | 'sdi' | 'countryIso' | 'defaultCurrency' | 'address' | 'province' | 'city' | 'zipCode' | 'internalCode' | 'phoneNumber' | 'faxNumber' | 'active' | 'createdOn' | 'updatedOn';
  direction?: 'asc' | 'desc';
  query?: string;
  mainContact?: string;
  vatNumber?: string;
  countryIso?: string;
  province?: string;
  city?: string;
  region?: string;
  companyTypeIds?: Array<number>;
  limit?: number;
  skip?: number;
}

export function companyControllerFind(http: HttpClient, rootUrl: string, params?: CompanyControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, companyControllerFind.PATH, 'get');
  if (params) {
    rb.query('field', params.field, {});
    rb.query('direction', params.direction, {});
    rb.query('query', params.query, {});
    rb.query('mainContact', params.mainContact, {});
    rb.query('vatNumber', params.vatNumber, {});
    rb.query('countryIso', params.countryIso, {});
    rb.query('province', params.province, {});
    rb.query('city', params.city, {});
    rb.query('region', params.region, {});
    rb.query('companyTypeIds', params.companyTypeIds, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyListResponse;
      }>;
    })
  );
}

companyControllerFind.PATH = '/company';
